import React, { useState } from "react";

// import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import Box from "@mui/material/Box";
import CalculateIcon from '@mui/icons-material/Calculate';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import PollIcon from '@mui/icons-material/Poll';
import SellIcon from '@mui/icons-material/Sell';
import Step from "@mui/material/Step";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Typography from "@mui/material/Typography";

import { convertDateTimeToDate, isToday, isYesterday } from "../helpers/dateFormat";
import { intToWord } from "../helpers/stringFormat";
import firstCharToUpper from "../helpers/stringFormat";
// import StatusList from "./StatusList";

const JourneyStepper = ({ product, productAction, valueModels, valueAction, surveys, surveyAction, costAction, presentationAction }) => {
    const [activeStep, setActiveStep] = useState(0);

    function CustomStepIcon({ active, index }) {
        // Render different icons for each step
        switch (index) {
            case 0:
                return <SellIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
            case 1:
                return <CalculateIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
            case 2:
                return <AutoGraphIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
            // case 2:
            //     return <PollIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
            // case 3:
            //     return <MonetizationOnIcon style={{ color: active ? 'green' : 'gray', fontSize: 24 }} />;
            default:
                return null;
        }
    }

    const productLogText = (product) => {
        if (!product) {
            return null
        }
        if (product.created_at === product.updated_at) {
            return (
                <Typography variant="body2">
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }} component="span">
                        Product
                    </Typography>
                    {' created '}{isToday(product.created_at) ? 'today' : isYesterday(product.created_at) ? 'yesterday' : convertDateTimeToDate(product.created_at)}
                </Typography>
            )
        }
        else {
            return (
                <Typography variant="body2">
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }} component="span">
                        Product
                    </Typography>
                    {' updated '}{isToday(product.created_at) ? 'today' : isYesterday(product.created_at) ? 'yesterday' : convertDateTimeToDate(product.updated_at)}
                </Typography>
            )
        }
    }

    const valueLogText = (models) => {
        if (models.length === 0) {
            return (
                <Typography variant="body2">
                    Create Value Model
                </Typography>
            )
        }
        else {
            return (
                <Typography variant="body2">
                    {`${models.length < 10 ? firstCharToUpper(intToWord(models.length)) : models.length} created `}
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }} component="span">
                        Value Model{models.length > 1 ? 's' : ''}
                    </Typography>
                </Typography>
            )
        }
    }

    // const segmentLogText = () => {
    //     return (
    //         <Typography variant="body2">
    //             Create Customer Segment
    //         </Typography>
    //     )
    // }

    const presentationLogText = () => {
        return (
            <Typography variant="body2">
                Generate Presentation
            </Typography>
        )
    }

    // const surveyLogText = (surveys) => {
    //     if (Object.values(surveys).length === 0) {
    //         return (
    //             <Typography variant="body2">
    //                 Set up Survey
    //             </Typography>
    //         )
    //     }
    //     else {
    //         return (
    //             <Typography variant="body2">
    //                 {`${Object.values(surveys).length < 10 ? firstCharToUpper(intToWord(Object.values(surveys).length)) : Object.values(surveys).length} `}
    //                 <Typography variant="body2" sx={{ fontWeight: 'bold' }} component="span">
    //                     Survey{Object.values(surveys).length > 1 ? 's' : ''}
    //                 </Typography>
    //             </Typography>
    //         )
    //     }
    // }

    return (
        <Box>
            <Stepper activeStep={activeStep} nonLinear orientation="vertical">
                <Step key="product">
                    <StepLabel
                        StepIconComponent={(props) => <CustomStepIcon {...props} index={0} />}
                        onClick={() => setActiveStep(0)}
                        style={{ cursor: 'pointer' }} // Optional: Show pointer cursor on hover
                    >
                        {productLogText(product)}
                    </StepLabel>
                    <StepContent>
                        {productAction()}
                    </StepContent>
                </Step>
                <Step key="valueModels">
                    <StepLabel
                        StepIconComponent={(props) => <CustomStepIcon {...props} index={1} />}
                        onClick={() => setActiveStep(1)}
                        style={{ cursor: 'pointer' }} // Optional: Show pointer cursor on hover
                    >
                        {valueLogText(valueModels)}
                    </StepLabel>
                    <StepContent>
                        {valueAction()}
                    </StepContent>
                </Step>
                {/* <Step key="segment">
                    <StepLabel
                        StepIconComponent={(props) => <CustomStepIcon {...props} index={2} />}
                        onClick={() => setActiveStep(2)}
                        style={{ cursor: 'pointer' }} // Optional: Show pointer cursor on hover
                    >
                        {segmentLogText()}
                    </StepLabel>
                    <StepContent>
                        {valueAction()}
                    </StepContent>
                </Step>                 */}
                <Step key="presentation">
                    <StepLabel
                        StepIconComponent={(props) => <CustomStepIcon {...props} index={2} />}
                        onClick={() => setActiveStep(2)}
                        style={{ cursor: 'pointer' }} // Optional: Show pointer cursor on hover
                    >
                        {presentationLogText()}
                    </StepLabel>
                    <StepContent>
                        {presentationAction()}
                    </StepContent>
                </Step>
                {/* <Step key="surveys">
                    <StepLabel
                        StepIconComponent={(props) => <CustomStepIcon {...props} index={2} />}
                        onClick={() => setActiveStep(2)}
                        style={{ cursor: 'pointer' }} // Optional: Show pointer cursor on hover
                    >
                        {surveyLogText(surveys)}
                    </StepLabel>
                    <StepContent>
                        {Object.values(surveys).length > 0 &&
                            <Typography variant="caption">
                                Survey{Object.values(surveys).length > 1 ? 's have' : ' has'} current status{Object.values(surveys).length > 1 ? 'es' : ''}:
                            </Typography>
                        }
                        <StatusList
                            data={surveys}
                            typeName="survey"
                        />
                        {surveyAction()}
                    </StepContent>
                </Step>
                <Step key="costs">
                    <StepLabel
                        StepIconComponent={(props) => <CustomStepIcon {...props} index={3} />}
                        onClick={() => setActiveStep(3)}
                        style={{ cursor: 'pointer' }} // Optional: Show pointer cursor on hover
                    >
                        Forecast Costs
                    </StepLabel>
                    <StepContent>
                        <Typography variant="caption">
                            Costs are calculated on a company level
                        </Typography>
                        {costAction()}
                    </StepContent>
                </Step> */}
            </Stepper>
        </Box>
    )
}

export default JourneyStepper